import React, { useState } from "react";
import css from "@/components/Listing/table/.module.scss";
import Toast from "@/components/toast/toast";
import Icon from "@/components/icon";
import Link from "next/link";
import { useIsOwner } from "@/contexts/auth/auth.provider";

const dailyFields = [
  {
    label: { ar: "رقم الترخيص" },
    name: "mot_license_number",
  },
];
const generalFields = [
  {
    label: { ar: "رخصة الإعلان" },
    name: "ad_license_number",
  },
  {
    label: { ar: "المخطط و القطعة" },
    name: "plan_parcel_no",
  },
  {
    label: { ar: "رابط رخصة الإعلان" },
    name: "ad_license_url",
  },
  {
    label: { ar: "المساحة حسب الصك" },
    name: "deed_area",
  },
];
const tab2Fields = [
  {
    label: { ar: "الضمانات ومدتها" },
    name: "guarantees_and_their_duration",
  },
  {
    label: { ar: "الإلتزامات" },
    name: "obligations_on_the_property",
  },
  {
    label: { ar: "عمولة نقل الملكية" },
    name: "ownership_transfer_fee_type",
  },
  {
    label: { ar: "اسم الموظف" },
    name: "responsible_employee_name",
  },
  {
    label: { ar: "رقم الموظف" },
    name: "responsible_employee_phone_number",
  },
  {
    label: { ar: "الملاحظات" },
    name: "notes",
  },
];

const tab3Fields = [
  { label: { ar: "المنطقة" }, name: "location_region" },
  { label: { ar: "المدينة" }, name: "location_city" },
  { label: { ar: "الحي" }, name: "location_district" },
  { label: { ar: "الشارع" }, name: "location_street" },
  { label: { ar: "الرمز البريدي" }, name: "location_postal_code" },
  {
    label: { ar: "رقم المبنى" },
    name: "location_building_number",
  },
  {
    label: { ar: "الرقم الإضافي" },
    name: "location_additional_number",
  },
];

export function TabsSpecs({ listing } = {}) {
  const [active, setActive] = useState(0);
  const isOwner = useIsOwner(listing);
  const tab1Fields = listing.daily_rentable ? dailyFields : generalFields;
  if (!listing) return null;

  return (
    <div>
      <div
        className={css.tabs + " " + (listing.daily_rentable ? css.daily : "")}
      >
        <div className={css.header}>
          <div
            onClick={() => setActive(0)}
            className={`${css.tab} ${active === 0 && css.active}`}
          >
            معلومات الإعلان
          </div>
          {listing.daily_rentable ? null : (
            <>
              <div
                onClick={() => setActive(1)}
                className={`${css.tab} ${active === 1 && css.active}`}
              >
                معلومات إضافية
              </div>

              <div
                onClick={() => setActive(2)}
                className={`${css.tab} ${active === 2 && css.active}`}
              >
                تفاصيل الموقع
              </div>
            </>
          )}
        </div>
        <div className={css.body}>
          {active === 0 && (
            <div className={css.tab1}>
              <div className={css.item}>
                <span className={css.label}>رقم الإعلان</span>
                <div className={css.copy}>
                  <span>{listing.id}</span>
                  <button
                    onClick={(e) => {
                      navigator.clipboard.writeText(listing.id);
                      Toast("تم نسخ رقم الإعلان", {
                        cls: "success",
                        elm: e.target,
                      });
                    }}
                  >
                    <Icon name="copyLink-gray" width={15} height={15} />
                    نسخ
                  </button>
                </div>
              </div>
              {tab1Fields.map((field) =>
                listing[field.name] ? (
                  <div className={css.item} key={field.name}>
                    <span className={css.label}>{field.label.ar}</span>
                    <span>{listing[field.name]}</span>
                  </div>
                ) : listing.extended_details?.[field.name] ? (
                  <div className={css.item} key={field.name}>
                    <span className={css.label}>{field.label.ar}</span>
                    {field.name === "ad_license_url" ? (
                      <a
                        target="_blank"
                        href={listing.extended_details[field.name]}
                      >
                        الرابط
                      </a>
                    ) : (
                      <span>{listing.extended_details[field.name]}</span>
                    )}
                  </div>
                ) : null,
              )}
              {!!listing?.extended_details?.end_date && (
                <div className={css.item}>
                  <span className={css.label}>تاريخ نهاية الترخيص</span>
                  <span>{listing?.extended_details?.end_date}</span>
                </div>
              )}
              {listing?.extended_details?.ad_source && (
                <div className={css.item}>
                  <span className={css.label}>مصدر الإعلان</span>
                  <span>{listing?.extended_details?.ad_source}</span>
                </div>
              )}
              {(!listing.daily_rentable || isOwner) && (
                <>
                  <div className={css.item}>
                    <span className={css.label}>تاريخ الإضافة</span>
                    <span>{listing?.create_time}</span>
                  </div>
                  <div className={css.item}>
                    <span className={css.label}>آخر تحديث</span>
                    <span>{listing?.updateAtFormatted}</span>
                  </div>
                  <div className={css.item}>
                    <span className={css.label}>المشاهدات</span>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        paddingInlineEnd: "1rem",
                      }}
                    >
                      <span>{listing.views}</span>
                      <Link href={`/listings/${listing.id}/statistics`}>
                        عرض المزيد
                      </Link>
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
          {listing.daily_rentable ? null : (
            <>
              {active === 1 && (
                <div className={css.tab2} data-nosnippet>
                  {tab2Fields.map((field) => {
                    if (
                      (field.name === "responsible_employee_name" ||
                        field.name === "responsible_employee_phone_number") &&
                      listing.status === 4
                    )
                      return null;
                    return (
                      <div className={css.item} key={field.name}>
                        <span className={css.label}>{field.label.ar}</span>

                        <span>
                          {listing?.extended_details?.[field.name] || "لا يوجد"}
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}
              {active === 2 && (
                <div className={css.tab3}>
                  {tab3Fields.map((field) => (
                    <div className={css.item} key={field.name}>
                      <span className={css.label}>{field.label?.ar}</span>
                      <span>
                        {listing?.extended_details?.[field.name] || "لايوجد"}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
